<template>
    <div class="rb">

        <div ref="Rmain" class="Rmain" :style="{ width: '480px', height: '240px' }"></div>
    </div>
</template>

<script>

export default {
    name: 'template4.rightBottom4',
    data() {
        return {
            chartDom: "",
            myChart: "",
            option: "",
            TmyChart: "",
            Toption: "",
            titleName4: "",
        }
    },

    beforeDestroy() {
        clearInterval(this.timer);
    },
    methods: {
        TdrawLine() {
            var echarts = require('echarts');
            var TmyChart = echarts.init(this.$refs.Rmain);
            let myDate = ['一季度', '二季度', '三季度', '四季度'];
            let data1 = [16, 20, 18, 10]
            let data2 = [12, 15, 13, 7]
            var Toption = {
                title: [{
                    text: '万元',
                    top: '20',
                    left: '24',
                    textStyle: {
                        color: "#979AA0",
                        fontSize: 12,
                    },
                },
                ],
                grid: {
                    left: '7%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true
                },
                // legend: [{
                //     show: true,
                //     x: '20%',
                //     y: '20%',

                // },
                // ],
                xAxis:
                {
                    type: 'category',
                    data: myDate,
                    // boundaryGap: false,
                    axisLine: {
                    lineStyle:{
                        color:'#254e76',
                        width:3,
                    }},
                    axisLabel: {
                        margin: 22,
                        padding: [0, 20, 0, 20],
                        interval: 0,//文字全部显示
                        textStyle: {
                            fontSize: 12,
                            color: '#979AA0' // 这里将 x 轴文本颜色设为灰白色
                        }
                    },
                },

                yAxis: {
                    // type: 'value',
                    // min: 0, // 设置y轴刻度的最小值
                    // max: 20,  // 设置y轴刻度的最大值
                    splitNumber: 3,  // 设置y轴刻度间隔个数
                    axisLabel: {
                        textStyle: {
                            color: '#979AA0' // 这里将 x 轴文本颜色设为灰白色
                        }
                    },
                    axisLine: {
                   
                       show:false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed',
                            color: "rgba(231,241,251,.2)"
                        }
                    }
                },
                // Declare several bar series, each will be mapped
                // to a column of dataset.source by default.
                series: [
                    {
                        data: data1,
                        type: 'bar',
                        name: '',
                        barWidth: 15,
                        label: {
                            normal: {
                                show: false,
                                position: 'top',
                                color: '#fff'
                            },
                            show: true,
                        },
                        barGap: '100%',
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                    offset: 0.2,
                                    color: '#50e7a9'
                                },
                                {
                                    offset: 1,
                                    color: "#1c4b46"
                                }
                               
                            ]),
                        }
                    },
                    {
                        data: data2,
                        type: 'bar',
                        name: '',
                        
                        barWidth: 15,
                        label: {
                            normal: {
                                show: false,
                                position: 'top',
                                color: '#fff'
                            },
                            show: true,
                        },

                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                    offset: 0.2,
                                    color: '#0288e9'
                                },
                                {
                                    offset: 1,
                                    color: "#0f364f"
                                }
                            ]),
                        }
                    }

                ]
            };

            Toption && TmyChart.setOption(Toption);
            setInterval(function () {
                TmyChart.clear();
                Toption && TmyChart.setOption(Toption);
            }, 5000)
        },
    },
    mounted() {
        this.$nextTick(() => {
            // this.drawLine(); //需要刷新的数据
            this.TdrawLine(); //需要刷新的数据
        });



    },
}
</script>

<style scoped>
.rb {
    width: 480px;
    height: 240px;
    padding: 10px 0;
    display: flex;
    position: relative;

    box-sizing: border-box;
}

.Rmain {
    position: absolute;
    left: -12px;
    top: 0px;
    /* width: 480px; */
    /* height: 240px; */
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    padding: 0px;
    margin: 0px;
    border-width: 0px;
}
</style>